import { WorkoutType } from './workouttype';

export interface IHomeWorkoutDuration {
  workoutDurationInMinutes: number;
}

const warmupSecs = 181;
const warmdownSecs = 141;
const quarterSecs = 12 * 60;
const breakSecs = 20 + 2;

export const homeWorkoutDurationConfig = {
  [WorkoutType.QuickHomeOrStaticCardioWorkout]: (warmupSecs + warmdownSecs + quarterSecs),
  [WorkoutType.MediumHomeOrStaticCardioWorkout]: (warmupSecs + warmdownSecs + (quarterSecs * 2) + breakSecs),
  [WorkoutType.FullHomeOrStaticCardioWorkout]: (warmupSecs + warmdownSecs + (quarterSecs * 3) + (breakSecs * 2)),
  [WorkoutType.ExtraLongHomeOrStaticCardioWorkout]: (warmupSecs + warmdownSecs + (quarterSecs * 4) + (breakSecs * 3)),
};

export const getWorkoutDuration = (workoutType: WorkoutType, playbackSpeed: number = 1): IHomeWorkoutDuration => {
  const secsPerMinute = 60 * playbackSpeed;
  const workoutDuration = homeWorkoutDurationConfig[workoutType];
  return {
    workoutDurationInMinutes: workoutDuration / secsPerMinute,
  };
};
